import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useCallback, useMemo } from 'react';
import { styled } from 'styled-components';
import { useI18n } from '@design-system/i18n';
import { Tag, TAG_DEFAULT_MAX_WIDTH } from '@design-system/tag';
export const TagsList = ({ maxWidth = TAG_DEFAULT_MAX_WIDTH, multi, onChange, selectedTagNames = [], showAllTag, tags, variant = 'bold', }) => {
    const { __ } = useI18n();
    const ALL_TAG = useMemo(() => ({
        label: __('All'),
        name: 'all',
    }), [__]);
    const toggleFilter = useCallback((name) => {
        if (name === ALL_TAG.name) {
            onChange === null || onChange === void 0 ? void 0 : onChange([]);
            return;
        }
        let newSelectedTagNames = [];
        if (multi) {
            newSelectedTagNames = selectedTagNames.includes(name)
                ? selectedTagNames.filter((n) => n !== name)
                : [...selectedTagNames, name];
        }
        else {
            newSelectedTagNames = selectedTagNames.includes(name) ? [] : [name];
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(newSelectedTagNames);
    }, [multi, onChange, selectedTagNames, ALL_TAG.name]);
    const commonProps = {
        flex: '0 0 auto',
        role: 'checkbox',
    };
    const allTagSelected = selectedTagNames.length === 0 || selectedTagNames.includes(ALL_TAG.name);
    return (_jsxs(_Fragment, { children: [(multi || showAllTag) && (_createElement(StyledTag, Object.assign({}, commonProps, { "aria-checked": allTagSelected, key: ALL_TAG.name, label: ALL_TAG.label, maxWidth: maxWidth, name: ALL_TAG.name, onClick: toggleFilter, selected: allTagSelected, variant: variant }))), tags.map(({ label, name }) => {
                const selected = selectedTagNames.includes(name);
                return (_createElement(StyledTag, Object.assign({}, commonProps, { "aria-checked": selected, key: name, label: label, maxWidth: maxWidth, name: name, onClick: toggleFilter, selected: selected, variant: variant })));
            })] }));
};
const StyledTag = styled(Tag).attrs({
    mb: 3,
    mr: 3,
}) ``;
//# sourceMappingURL=TagsList.js.map